import { inject, Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { RolePermissionService } from "../authentication/services/role-permission.service";
import { catchError, map, Observable, of } from "rxjs";
import { LogService } from "../../shared/service/logging/log.service";

@Injectable()
export class CoreMemberAccessGuardService {
  rolePermissionService = inject(RolePermissionService);
  router = inject(Router);
  logger = inject(LogService);

  coreMemberAccess$ = this.rolePermissionService.hasCoreMemberAccess$;

  // TODO: should this navigate to a "forbidden" page?
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.coreMemberAccess$.pipe(
      map((hasAccess) => {
        if (!hasAccess) {
          this.logger.debug("Access denied!");
          this.router.navigateByUrl("/");
        }
        return hasAccess;
      }),
      catchError(() => {
        this.router.navigateByUrl("/");
        return of(false);
      })
    );
  }
}

export const CoreMemberAccessGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> => {
  return inject(CoreMemberAccessGuardService).canActivate(next, state);
};
